
export async function getBaseRequestData() {
  let properties = {};
  await Excel.run(async (context) => {
    let recordNumber = context.workbook.properties.custom.getItemOrNullObject("recordNumber");
    let RecordDocument = context.workbook.properties.custom.getItemOrNullObject("RecordDocument");
    let template = context.workbook.properties.custom.getItemOrNullObject("HorusTemplate");
    let ExternalEdition = context.workbook.properties.custom.getItemOrNullObject("ExternalEditionId");
    let UserId = context.workbook.properties.custom.getItemOrNullObject("UserId");

    await context.load(recordNumber);
    await context.load(RecordDocument);
    await context.load(template);
    await context.load(ExternalEdition);
    await context.load(UserId);

    await context.sync();

    properties = {
        recordNumber: recordNumber.value,
        RecordDocument: RecordDocument.value,
        template: template.value,
        ExternalEdition: ExternalEdition.value,
        UserId: UserId.value,
    };
  });

  return properties;
}

export async function getBaseRequestHeader() {
  let headers = {};    

  await Excel.run(async (context) => {
    let token = context.workbook.properties.custom.getItemOrNullObject("Token");

    await context.load(token);
    await context.sync();

    headers = {
        Authorization: token.value,
        "Access-Control-Allow-Origin": "*"
    };
  });

  return headers;
}

export async function getAPIUrl() {
    let apiUrl;
    
    await Excel.run(async (context) => {

      let apiUrlProp = context.workbook.properties.custom.getItemOrNullObject("ApiUrl");
      
      await context.load(apiUrlProp);
  
      await context.sync();
  
      apiUrl = apiUrlProp.value;
    });
  
    return apiUrl;
  }
  
  export async function getRecordNumber() {
    let recordNumberValue;

    await Excel.run(async (context) => {

      let recordNumber = context.workbook.properties.custom.getItemOrNullObject("recordNumber");

      await context.load(recordNumber);
  
      await context.sync();
  
      recordNumberValue = recordNumber.value;
    });
  
    return recordNumberValue;
  }